import { AlertCircle, RotateCw } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { getApiErrorMessage } from '@/lib/api/error';
import { NETWORK_ERROR_COPY } from './list-state-copy';

interface QueryErrorStateProps {
  error: unknown;
  onRetry: () => void | Promise<unknown>;
  isRetrying?: boolean;
  title?: string;
  fallbackMessage?: string;
  className?: string;
}

export function QueryErrorState({
  error,
  onRetry,
  isRetrying = false,
  title = NETWORK_ERROR_COPY.title,
  fallbackMessage = NETWORK_ERROR_COPY.fallbackMessage,
  className,
}: QueryErrorStateProps) {
  const message = getApiErrorMessage(error, fallbackMessage);

  return (
    <Alert variant="destructive" className={cn(className)}>
      <AlertCircle />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>
        <p>{message}</p>
        <Button
          type="button"
          size="sm"
          variant="outline"
          disabled={isRetrying}
          onClick={() => {
            void onRetry();
          }}
        >
          <RotateCw
            data-icon="inline-start"
            className={isRetrying ? 'animate-spin' : undefined}
          />
          {isRetrying
            ? NETWORK_ERROR_COPY.retryingLabel
            : NETWORK_ERROR_COPY.retryLabel}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
